export interface Bonus {
  number: string
  value: string
  title: string
  description: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    value: '$50',
    title: 'The Jazz Comping Bible',
    description:
      'Every comping pattern your students need, organized by feel and difficulty — voicings, rhythms, and drills ready to hand out.',
    image: 'https://cdn.magicpatterns.com/uploads/nn9BW7Eqg5Ao83xSGVnjEF/jazz_1.webp',
  },
  {
    number: '02',
    value: '$50',
    title: 'ii-V-I Mastery in Every Key',
    description:
      'The full cycle worked out in all twelve keys, with voice leading, substitutions, and practice routes for each level.',
    image: 'https://cdn.magicpatterns.com/uploads/p17FZVosj3vtbRqrcV2qcm/jazz_2.webp',
  },
  {
    number: '03',
    value: '$50',
    title: 'Jazz Standards Fast-Track Library',
    description:
      'Mapped-out standards with melody, changes, and improvisation notes so you can teach a new tune with zero prep.',
    image: 'https://cdn.magicpatterns.com/uploads/pTRKo3EMerGeaTPbobxcKk/jazz_3.webp',
  },
  {
    number: '04',
    value: '$50',
    title: 'Jam Session Survival Guide',
    description:
      'Etiquette, counting-in, trading choruses, and recovery tactics — everything students need before their first session.',
    image: 'https://cdn.magicpatterns.com/uploads/jponu5iWTzNDZ47dwjbcYT/jazz_4.webp',
  },
  {
    number: '05',
    value: '$50',
    title: 'The Transcription Masterclass',
    description:
      'A step-by-step method for teaching students to lift lines by ear, from four-bar phrases to full solos.',
    image: 'https://cdn.magicpatterns.com/uploads/vQVrnXBPQpeHH4HWKPX92W/jazz_5.webp',
  },
]
